export default __webpack_public_path__ + "css/supplierDashboard.bundle.css";